import Login from "./pages/Login";
import Admin from "./pages/Admin";
import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import "@/App.css";

import Header from "./components/Header";
import Footer from "./components/Footer";
import FloatingButtons from "./components/FloatingButtons";
import LeadPopup from "./components/LeadPopup";

import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import BusinessFranchisePage from "./pages/BusinessFranchisePage";
import EVChargingPage from "./pages/EVChargingPage";
import ProductPage from "./pages/ProductPage";
import ProjectsPage from "./pages/ProjectsPage";
import { BlogListPage, BlogDetailPage } from "./pages/BlogPage";
import ContactPage from "./pages/ContactPage";
import CalculatorPage from "./pages/CalculatorPage";

function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const tryScroll = () => {
        const el = document.getElementById(hash.replace("#", ""));
        if (el) {
          const y = el.getBoundingClientRect().top + window.scrollY - 20;
          window.scrollTo({ top: y, behavior: "smooth" });
        }
      };
      setTimeout(tryScroll, 80);
    } else {
      window.scrollTo({ top: 0, behavior: "instant" });
    }
  }, [pathname, hash]);

  return null;
}

function AppShell() {
  const location = useLocation();

  const isAdmin = location.pathname === "/admin";

  return (
    <>
      <ScrollToTop />

      {!isAdmin && <Header />}

      <main>
        <Routes>

          {/* 🔐 PROTECTED ADMIN ROUTE */}
          <Route
            path="/admin"
            element={
              localStorage.getItem("auth") === "true"
                ? <Admin />
                : <Login />
            }
          />

          {/* LOGIN PAGE */}
          <Route path="/login" element={<Login />} />

          {/* WEBSITE ROUTES */}
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/business-franchise" element={<BusinessFranchisePage />} />
          <Route path="/ev-charging" element={<EVChargingPage />} />
          <Route path="/products/:slug" element={<ProductPage />} />
          <Route path="/projects" element={<ProjectsPage />} />
          <Route path="/blog" element={<BlogListPage />} />
          <Route path="/blog/:slug" element={<BlogDetailPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/calculator" element={<CalculatorPage />} />

          {/* FALLBACK */}
          <Route path="*" element={<HomePage />} />

        </Routes>
      </main>

      {!isAdmin && <Footer />}
      {!isAdmin && <FloatingButtons />}
      {!isAdmin && <LeadPopup />}
    </>
  );
}

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <AppShell />
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </div>
    </HelmetProvider>
  );
}

export default App;